import { createContext, use } from "react";
import type { Session } from "./types";

export type SessionState = {
  session: Session | null;
  loading: boolean;
  refresh(): Promise<void>;
  signOut(): Promise<void>;
};

export const SessionContext = createContext<SessionState | null>(null);

export function useSession() {
  const value = use(SessionContext);
  if (!value) throw new Error("Session provider is unavailable");
  return value;
}
